"use strict";

(function (Drupal) {
  Drupal.behaviors.carousel_global = {
    attach: function attach(context, settings) {
      // We do not want this to affect the home hero carousel, which has lots of special JS going on but can share some of
      // the global CSS (so it has the `carousel--component` class).
      var carousels = context.querySelectorAll('.carousel--component:not(.home-hero-carousel)');
      if (!carousels.length) {
        return;
      }
      var sizeMq;
      var slideTransitionInterval;
      var classes = {
        active: 'js-slide-is-active',
        changing: 'js-slide-is-changing',
        desktop: 'js-carousel-is-desktop',
        no_progress: 'no-progress-bar',
        left: 'js-carousel-is-left',
        mobile: 'js-carousel-is-mobile',
        next: 'js-slide-is-next',
        processed: 'js-is-processed'
      };
      carousels.forEach(function (carousel) {
        var firstSlide = carousel.querySelector('.carousel--item:first-of-type');
        var pager = carousel.querySelector('.carousel--pager');
        var mobilePager = carousel.querySelector('.carousel--pager-mobile');
        var slideCount = carousel.querySelectorAll('.carousel--item').length;

        /* Set the carousel height and mobile pager positioning on resize. */
        var setCarouselHeight = function setCarouselHeight() {
          var slideHeights = [];
          var slideHeight;
          var tallestSlide;
          var slides = carousel.querySelectorAll('.carousel--item');
          var windowHeight = window.innerHeight;
          if (windowHeight == window.innerHeight) {
            // The slides in the carousel are absolutely positioned, so we need to set the height with JS.
            // We load all of the slides in the carousel and pick the tallest one.
            slides.forEach(function (slide) {
              // Our hidden slides need to temporarily have block display so we get the accurate height.
              if (!slide.classList.contains(classes.active)) {
                slide.style.display = 'block';
              }
              // Push heights into an array.
              slideHeights.push(parseInt(window.getComputedStyle(slide).height));
              slideHeight = Math.max.apply(Math, slideHeights);
              // The tallest slide is the element that matches the max slide height.
              if (parseInt(window.getComputedStyle(slide).height) == slideHeight) {
                tallestSlide = slide;
              }
              // Hide the non active slide.
              if (!slide.classList.contains(classes.active)) {
                slide.style.removeProperty('display');
              }

              // Quoted carousel needs some extra height for the CTA.
              if (carousel.classList.contains('block-quoted-carousel')) {
                slideHeight = slideHeight + 40;
              }
            });

            // The height of the carousel should equal to the highest number in the array/tallest slide.
            carousel.style.height = "".concat(slideHeight, "px");
            if (carousel.classList.contains(classes.no_progress) || !carousel.classList.contains(classes.mobile)) {
              return;
            }
            // If we're on mobile, we need to position the pager.
            var activeImage = tallestSlide.querySelector('div[class*="image"]');
            var activeImageStyle = parseInt(window.getComputedStyle(activeImage).height);
            // The pager is always at the bottom of the image wrapper + 50px.
            mobilePager.style.top = "".concat(activeImageStyle + 50, "px");
          }
        };

        /**
         * Establish the slide order and what slide is next.
         * @param {element} element An optional element (usually a bullet).
         * @param {boolean} left If we are swiping left we handle the transition differently.
         */
        var slideTransition = function slideTransition(element, left) {
          var nextSlide;
          var activeBullet = mobilePager.querySelector(".".concat(classes.active));
          if (element) {
            // If we're passing the element, we set the next slide based on the element index.
            // This matches the target slide.
            var slideIndex = element.getAttribute('data-index');
            nextSlide = carousel.querySelector(".carousel--item[data-index=\"".concat(slideIndex, "\"]"));
            slideAnimation(nextSlide, element);
            element.classList.add(classes.active);
          } else {
            var nextIndex;
            var nextBullet;

            // If we're swiping left we reverse the default behavior.
            if (left) {
              // Add the left transition classes if they aren't there.
              if (!carousel.classList.contains(classes.left)) {
                carousel.classList.add(classes.left);
              }
              nextIndex = parseInt(carousel.querySelector(".".concat(classes.active)).getAttribute('data-index')) - 1;
              // Since we're subtracting, the nextIndex needs to be above zero.
              if (nextIndex > 0) {
                nextBullet = mobilePager.querySelector("button[data-index=\"".concat(nextIndex, "\"]"));
                nextSlide = carousel.querySelector(".carousel--item[data-index=\"".concat(nextIndex));
              } else {
                // If we're rewinding, we go to the last items in the pager/carousel.
                nextBullet = mobilePager.querySelector('button:last-of-type');
                nextSlide = carousel.querySelector('.carousel--item:last-of-type');
              }
            } else {
              // Remove the left transition classes if they are there.
              if (carousel.classList.contains(classes.left)) {
                carousel.classList.remove(classes.left);
              }
              nextIndex = parseInt(carousel.querySelector(".".concat(classes.active)).getAttribute('data-index')) + 1;
              // If we're moving forward, we go to the next items until we're equal to the
              // slide count. Then we go back to the beginning.
              // @TODO – pager math might be able to be abstracted, TBD.
              if (nextIndex <= slideCount) {
                nextBullet = mobilePager.querySelector("button[data-index=\"".concat(nextIndex, "\"]"));
              } else {
                nextBullet = mobilePager.querySelector("button:first-child");
              }
              nextSlide = carousel.querySelector(".".concat(classes.next));
            }
            nextBullet.classList.add(classes.active);
            slideAnimation(nextSlide);
          }
          activeBullet.classList.remove(classes.active);
          nextSlide.classList.add(classes.next);

          // Global pager increment is in utils. Don't fire on non-progress bar carousels.
          if (!carousel.classList.contains(classes.no_progress)) {
            Drupal.behaviors.dart_utils.incrementPager(pager, slideCount);
          }
        };
        var slideAnimation = function slideAnimation(nextSlide, element) {
          var activeSlide = carousel.querySelector(".".concat(classes.active));
          activeSlide.classList.add(classes.changing);
          carousel.classList.add(classes.changing);
          // We set the display to be block at animation time. Otherwise there
          // is a display: block slide below the active slide and we can tab to it.
          if (!carousel.classList.contains(classes.no_progress)) {
            nextSlide.style.display = 'block';
          } else {
            // The non-progress carousels have display: flex instead of display: block;
            nextSlide.style.display = 'flex';
          }

          // We set a one second timeout to do the class swapping so that it happens
          // after the slide animates.
          setTimeout(function () {
            activeSlide.classList.remove(classes.changing);
            activeSlide.classList.remove(classes.active);
            nextSlide.classList.add(classes.active);
            nextSlide.classList.remove(classes.next);
            nextSlide.style.removeProperty('display');
            carousel.classList.remove(classes.changing);

            // If the next slide has a nextElementSibling, that's the next slide.
            // Otherwise it's the first slide.
            if (!element) {
              if (nextSlide.nextElementSibling) {
                nextSlide.nextElementSibling.classList.add(classes.next);
              } else {
                firstSlide.classList.add(classes.next);
              }
            }
          }, 1000);
        };
        var carouselMobilePager = function carouselMobilePager() {
          var pagerDots = mobilePager.querySelectorAll('button');
          if (!pagerDots.length) {
            return;
          }
          pagerDots.forEach(function (el) {
            el.addEventListener('click', function (e) {
              if (!e.target.classList.contains(classes.active)) {
                // Click a pager dot, go to the slide.
                slideTransition(e.target);
              }
            });
          });
        };
        var handleSwipe = function handleSwipe() {
          var hammer = new Hammer(carousel);
          hammer.on('swipeleft', function () {
            // The left transition is reversed so we pass a null bullet and a boolean.
            slideTransition(null, true);
          });
          hammer.on('swiperight', function () {
            // The right transition is normal so we don't need to pass anything.
            slideTransition();
          });
        };

        /**
         * Handle the carousel controls.
         */
        var carouselControls = function carouselControls() {
          var controlsContainer = carousel.querySelector('.carousel--controls');
          if (!controlsContainer) {
            return;
          }
          var controls = controlsContainer.querySelectorAll('button');
          controls.forEach(function (el) {
            el.addEventListener('click', function () {
              var direction = el.getAttribute('data-direction');
              if (direction == 'left') {
                slideTransition(null, true);
              } else {
                slideTransition();
              }
            });
          });
        };
        /* Determine the menu type: desktop vs. mobile */
        var carouselType = function carouselType() {
          if (carousel.classList.contains(classes.no_progress)) {
            sizeMq = window.matchMedia('(min-width: 64rem)');
          } else {
            sizeMq = window.matchMedia('(min-width: 48rem)');
          }
          if (sizeMq.matches) {
            carousel.classList.add(classes.desktop);
            carousel.classList.remove(classes.mobile);
          } else {
            carousel.classList.remove(classes.desktop);
            carousel.classList.add(classes.mobile);
          }
        };

        /* Function that fires when carousel shifts from desktop->mobile or mobile->desktop. */
        var sizeChange = function sizeChange() {
          carouselType();
          carouselHandler();
        };

        /* Parent function that sets up the carousel based on type */
        var carouselHandler = function carouselHandler() {
          // Destkop-specific functions.
          if (carousel.classList.contains(classes.desktop)) {
            // Always set up controls on desktop.
            carouselControls();

            // When we're resizing to desktop we remove the inline height on the no-progress bar carousels.
            if (carousel.classList.contains(classes.no_progress)) {
              carousel.style.removeProperty('height');
            }

            // Only continue if we don't have a progress bar.
            if (carousel.classList.contains(classes.no_progress) || slideTransitionInterval) {
              return;
            }
            var progressBar = pager.querySelector('.progress-bar');
            var _progressTimeline = gsap.timeline({
              repeat: -1
            });

            // The slide transition happens every 10 seconds. There are no controls.
            slideTransitionInterval = setInterval(function () {
              slideTransition();
            }, 10000);
            if (_progressTimeline.isActive()) {
              Drupal.behaviors.dart_utils.resetProgressBar(_progressTimeline);
            } else {
              Drupal.behaviors.dart_utils.loadProgressBar(progressBar, _progressTimeline);
            }
          }

          // Mobile-specific functions.
          if (carousel.classList.contains(classes.mobile)) {
            // There is no auto advancing on mobile so we clear out the transition
            // if it exists.
            if (slideTransitionInterval && typeof progressTimeline != 'undefined') {
              clearInterval(slideTransitionInterval);
              slideTransitionInterval = false;
              Drupal.behaviors.dart_utils.killProgressBar(progressTimeline);
            }
            carouselMobilePager();
            handleSwipe();
          }
        };
        carouselType();
        carouselHandler();
        // Init height.
        setCarouselHeight();
        // We reset the height on resize. No debounce bc it literally makes the container bounce.
        window.addEventListener('resize', setCarouselHeight);
        sizeMq.addListener(sizeChange);
      });
    }
  };
})(Drupal);